
import axios from 'axios';

const api = axios.create({
baseURL: process.env.REACT_APP_API
// axios.defaults.headers.common = {'Authorization': `bearer ${token}`}
})
export default api;